import React, { useState } from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { AudioPlayer } from '../players/AudioPlayer';

/**
 * YesNo component that displays "Yes" and "No" buttons with corresponding audio based on the provided language ID.
 * 
 * @param {number} languageID - The ID of the language to fetch "Yes" and "No" answers in.
 * @returns {JSX.Element} A component with "Yes" and "No" buttons and an audio player.
 */
export function YesNo({ languageID }) {
    const [answerAudio, setAnswerAudio] = useState();

    const languageData = [
        {
            id: 1,
            yesAnswer: "Ja",
            noAnswer: "Nej",
            yesAudio: "https://sadima.lnu.se/Media/Ljudfiler/a1_yes_sw.mp3",
            noAudio: "https://sadima.lnu.se/Media/Ljudfiler/a2_no_sw.mp3"
        },
        {
            id: 2,
            yesAnswer: "نعم",
            noAnswer: "لا",
            yesAudio: "https://sadima.lnu.se/Media/Ljudfiler/a1_yes_ar.mp3",
            noAudio: "https://sadima.lnu.se/Media/Ljudfiler/a2_no_ar.mp3"
        },
        {
            id: 3,
            yesAnswer: "Yes",
            noAnswer: "No",
            yesAudio: "https://sadima.lnu.se/Media/Ljudfiler/a1_yes_en.mp3",
            noAudio: "https://sadima.lnu.se/Media/Ljudfiler/a2_no_en.mp3"
        }
    ];

    /**
     * Retrieves the language data object by its ID.
     */
    const getLanguageDataById = (id) => {
        return languageData.find((lang) => lang.id == id);
    }

    return (
        <>
            <ButtonToolbar className="yesno-toolbar justify-content-between">
                <Button
                    className="yesno d-flex justify-content-center d-md-table mx-auto"
                    variant="outline-success"
                    size="lg"
                    onClick={() => {
                        setAnswerAudio(getLanguageDataById(languageID).yesAudio);
                    }}>
                    <div className="text-container">
                        <p>{languageID !== 1 && getLanguageDataById(1).yesAnswer}</p>
                        <p className="medium-text">{getLanguageDataById(languageID).yesAnswer}</p>
                    </div>
                </Button>

                <Button
                    className="yesno d-flex justify-content-center d-md-table mx-auto"
                    variant="outline-danger"
                    size="lg"
                    onClick={() => {
                        setAnswerAudio(getLanguageDataById(languageID).noAudio);
                    }}>
                    <div className="text-container">
                        <p>{languageID !== 1 && getLanguageDataById(1).noAnswer}</p>
                        <p className="medium-text">{getLanguageDataById(languageID).noAnswer}</p>
                    </div>
                </Button>
            </ButtonToolbar>

            {answerAudio && <AudioPlayer url={answerAudio} />}
        </>
    );
}